import { Controller } from "@hotwired/stimulus"
/***
 * DisableWithController swaps button/link text with a loading message
 * and disables the element during navigation or form submission.
 *
 * This helps prevent duplicate clicks and makes the interaction feel responsive.
 * We use `requestAnimationFrame` to ensure the UI updates before Turbo replaces
 * the frame or page, avoiding the race condition where the loading text never shows.
 *
 * @example <caption>With a Rails `button_to` (form under the hood)</caption>
 *
 * <%= button_to "Reload",
 *       some_path,
 *       method: :get,
 *       data: {
 *         controller: "disable-with",
 *         disable_with_text_value: "Loading…",
 *         action: "click->disable-with#disable"
 *       } %>
 *
 ***/
export default class extends Controller {
  static values = { text: String }
  
  disable(event) {
    const el = event.currentTarget

    if (this.hasTextValue) {
      el.dataset.originalText = el.innerHTML
      el.innerHTML = this.textValue
    }

    requestAnimationFrame(() => {
      el.disabled = true
    })
  }
}
